import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogRoutingModule } from './blog-routing.module';
import { BlogComponent } from 'src/app/pages/blog/blog/blog.component';
import { BlogArticleUiPreviewComponent } from 'src/app/shared/blog-article-ui-preview/blog-article-ui-preview.component';
import { DesktopNewestBlogArticlePreviewComponent } from 'src/app/shared/desktop-newest-blog-article-preview/desktop-newest-blog-article-preview.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BlogPaginationComponent } from 'src/app/shared/blog-pagination/blog-pagination.component';
import { BlogArticleDetailComponent } from 'src/app/pages/blog/blog-article-detail/blog-article-detail.component';
import { BlogOtherArticlesCarouselComponent } from 'src/app/shared/blog-other-articles-carousel/blog-other-articles-carousel.component';
import { SwiperModule } from 'swiper/angular';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlogFullArticleContentComponent } from 'src/app/shared/blog-full-article-content/blog-full-article-content.component';
import { BlogArticlePreviewExternalComponent } from 'src/app/pages/blog/blog-article-preview-external/blog-article-preview-external.component';
import { ButtonModule } from 'src/app/shared/button/button.module';

@NgModule({
  declarations: [
    DesktopNewestBlogArticlePreviewComponent,
    BlogComponent,
    BlogPaginationComponent,
    BlogArticleDetailComponent,
    BlogOtherArticlesCarouselComponent,
    BlogFullArticleContentComponent,
    BlogArticlePreviewExternalComponent,
    BlogArticleUiPreviewComponent,
  ],
  imports: [
    CommonModule,
    BlogRoutingModule,
    TranslateModule,
    AngularSvgIconModule,
    SwiperModule,
    PreloadSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
  ],
  exports: [
    BlogComponent,
  ],
  providers: [
    TranslatePipe,
  ],

})
export class BlogModule { }
